export const translation = key => {
  return key;
};

export const noop = () => {};
